import { gql, useMutation } from "@apollo/client"
import React, { useEffect } from "react"

const GET_IMAGE = gql`
  mutation getImage($file_key: String!) {
    fileDownload(file_key: $file_key) {
      base64EncodedFile
    }
  }
`

export default function LineImage({ s3_key, observation_date }) {
  const [getImage] = useMutation(GET_IMAGE)
  const [imageBase64, setImageBase64] = React.useState()
  useEffect(() => {
    async function getImage() {
      const { data } = await getImage({ variables: { file_key: s3_key } })
      setImageBase64(data.fileDownload.base64EncodedFile)
    }
    getImage()
  }, [s3_key, getImage])

  return (
    <div>
      This is going to have images.
      {s3_key}
      {observation_date}
      <img alt="observation" src={`data:image/png;base64,${imageBase64}`} />
    </div>
  )
}
